/**
 * Firebase Configuration
 * These values are public and safe to expose in client-side code.
 *
 * IMPORTANT: If you update these values, also update them in:
 * - /public/firebase-messaging-sw.js (service worker can't import this file)
 */
export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCiIO2f7J8xkcwJF3qz7u6WdxARfcX12XM',
  authDomain: 'campuslush-be6b9.firebaseapp.com',
  projectId: 'campuslush-be6b9',
  storageBucket: 'campuslush-be6b9.appspot.com',
  messagingSenderId: '759654063187',
  appId: '1:759654063187:web:e85ee9b0472d953e077aa6',
};

/**
 * Firebase VAPID Key for Web Push
 * Get from Firebase Console > Project Settings > Cloud Messaging > Web Push certificates
 */
export const FIREBASE_VAPID_KEY = 'BBO8LiDV2J-If7YRBhD2UZr8jln4TJ81LGxX7Uyfc7YEv0Jbn2LVI4fEHN7hQNWBPKImXtroKl1DSkorc4FfH0U';
